module.exports = __webpack_public_path__ + "img/robot1lb2.2b4c8e27.png";